// @flow
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";
import CameraTab from "../index";

export default [{
	path: asAbsolute(uploaderConsts.SOURCES.CAMERA),
	component: CameraTab,
}];
